import removeAccents from 'remove-accents-esm';

class HDocumentFile {
	static cleanWord = (word: string) => {
		return removeAccents(word).toLowerCase();
	};
}

export default HDocumentFile;
